import {TouchableOpacity, Text} from 'react-native';
import React from 'react';
import {Props} from './model';
import {getFontWeight} from '../../../theme/default';
import {useStyles} from '../../../hooks/styles';

export default ({active, onPress, label, style, textStyle}: Props) => {
  const dataSetButton = {
    dataSet: {
      class: 'visually-impaired-button',
    },
  };

  const dataSetButtonText = {
    dataSet: {
      class: 'visually-impaired-button-text',
    },
  };

  const styles = useStyles(({theme}) => ({
    button: {
      height: 32,
      borderRadius: 5,
      paddingLeft: 5,
      paddingRight: 5,
      justifyContent: 'center',
      alignItems: 'center',
    },
    activeButton: {
      backgroundColor: '#000000',
    },
    buttonText: {
      fontSize: 16,
      fontWeight: getFontWeight('400'),
      fontFamily: theme.fonts.fontFamily.regular,
      lineHeight: 18,
      textAlign: 'center',
      color: '#000000',
    },
    activeButtonTextWhite: {
      fontWeight: getFontWeight('bold'),
      fontFamily: theme.fonts.fontFamily.bold,
      color: '#FFFFFF',
    },
  }));

  return (
    <TouchableOpacity
      testID='visually-imparied-button-id'
      activeOpacity={1}
      onPress={onPress}
      style={[styles.button, style, active && styles.activeButton]}
      {...dataSetButton}>
      <Text style={[styles.buttonText, textStyle, active && styles.activeButtonTextWhite]} {...dataSetButtonText}>
        {label}
      </Text>
    </TouchableOpacity>
  );
};
